import {PayloadAction, createReducer} from '@reduxjs/toolkit'
import {PageDates} from '@wix/wix-events-commons-statics'
import {updateDates} from '../actions/dates'

const initialState = {} as PageDates

export const dates = createReducer(initialState, builder =>
  builder.addCase(updateDates, (state, action: PayloadAction<PageDates>) => {
    state.events = {
      ...state.events,
      ...action.payload.events,
    }
    state.common = {
      ...state.common,
      ...action.payload.common,
    }
  }),
)
